import axios from 'axios';

export default class CapacitiesService {
  async getTableData(url, data, method) {
    const response = await axios({
      method,
      url,
      withCredentials: true,
      data,
    }).catch((error) => {
      console.log('getTableData, capacities', error);
      throw error;
    });
    return response.data;
  }

  async getDefaultCapacity(projectId, employeeId) {
    const response = await axios({
      method: 'GET',
      url: `/projects/${projectId}/capacity/data/employees/defaultCapacity/${employeeId}`,
      withCredentials: true,
    }).catch((error) => {
      console.log('getDefaultCapacity, capacities', error);
      throw error;
    });
    return response.data.defaultCapacity;
  }

  async updateDefaultCapacity(projectId, employeeId, capacity, weekId = undefined) {
    const response = await axios({
      method: 'POST',
      url: `/projects/${projectId}/capacity/data/employees/defaultCapacity`,
      withCredentials: true,
      data: {
        employeeId,
        weekId,
        defaultCapacity: capacity,
      },
    }).catch((error) => {
      console.log('updateDefaultCapacity, capacities', error);
      throw error;
    });
    return response.data;
  }
}
